import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { QuestionStatisticComponent } from './questions-statistic/questions-statistic.component';

const routes: Routes = [
    {
        path: 'council-members-questions',
        loadChildren: './council-members/council-members.module#CouncilMembersModule',
    },
    {
        path: 'organizational-unit-questions',
        loadChildren: './organizational-unit-questions/organizational-unit-questions.module#OrganizationalUnitQuestionsModule',
    },
    {
        path:'question-statistic', component: QuestionStatisticComponent
    },

];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class QuestionsRoutingModule { }
